import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Avatar,
  Image,
  Empty,
  Button,
  Modal,
  notification,
  Input,
  Menu,
  DatePicker,
  Pagination,
  Spin,
  DatePickerProps,
  Card
} from "antd";
import moment from 'moment';

// Locales

import { APIEndpointWeb, webapi } from "@client/web";
import { Cookies, useCookies } from "react-cookie";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE
} from "@constant/constant";
import "../../styles/grid/layout.less";
import HomeWebStatusStep from "../IsurerComponent/HomeWebStatusStep";
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { CheckCircleTwoTone, ExclamationCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import { set } from "lodash";
import { useHistory } from "react-router-dom";
const { Text } = Typography;

export interface IInsurance {
  insurance_name: string;
  request_date: string;
  name: string;
  cid: string;
  hospital_name: string;
  hcode: string;
  steps: [];
  logo: string;
  document_id: string;
}

export interface IStep {
  date: string;
  status: string;
}

export interface IPaginate {
  page: number;
  page_last: number;
  total: number;
}
export interface ChildProps {
  resUserDisplayLogo?: any;
}
dayjs.extend(customParseFormat);
const limit = 5;
let gPage = 1;
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const HomeWebStatusAgent: React.FC<ChildProps> = (props): JSX.Element => {
  const { resUserDisplayLogo } = props;
  const history = useHistory();
  const [resInsuranceStep, setResInsuranceStep] = useState<IInsurance[]>();
  const [postMedHistory, setPostMedHistory] = useState();
  const [resSearchName, setresSearchName] = useState("");
  const [WindowResize, setWindowResize] = useState(Number);
  const [datadefaultSelectedKeys, setdefaultSelectedKeys] = useState(["0"]);
  const [datavalueStep, setDatavalueStep] = useState("");
  const [idStep, setIdStep] = useState(Number);
  const [paginate, setPaginate] = useState<IPaginate>();
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [resSelectdate, setResSelectdate] = useState<Dayjs | any>('');
  const getCookies = new Cookies();
  const dayjs = require("dayjs");
  const utc = require("dayjs/plugin/utc");
  const timezone = require("dayjs/plugin/timezone");
  dayjs.extend(timezone);
  dayjs.extend(utc);

  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE
  ]);
  useEffect(() => {
    getStatusLoading(gPage, '', resSelectdate, startDate, endDate);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);
  const shared_token = getCookies.get("shared_token");
  useEffect(() => {
    checkCookie()
  }, []);
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };

  const checkCookie = async () => {
    webapi.get(`${APIEndpointWeb.checkCookie}`,
      {
        withCredentials: true,
      }
    ).then(() => {

    }).catch((error) => {
      console.log(error.response);
      if (error.response.status === 401) {
        history.push("/login");
      }
    })
  }

  const getStatus = (index: number, item: any) => {
    setIdStep(index);
    setdefaultSelectedKeys([index.toString()]);
    setDatavalueStep(item);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const caseCancle = (doc_id: any) => {
    Modal.confirm({
      title: 'คุณแน่ใจที่จะยกเลิกใช่หรือไม่?',
      icon: <ExclamationCircleOutlined />,
      okText: "ตกลง",
      cancelText: 'ยกเลิก',
      async onOk() {
        const dataStatus = {
          document_id: doc_id,
          status: true
        };
        try {
          const { data } = await webapi.post(
            `${APIEndpointWeb.RejectRequest}`, dataStatus,
            {
              withCredentials: true,
              // headers: { Authorization: `Bearer ${cookies.shared_token}` }
            }
          );
          getStatusLoading(1, resSearchName, resSelectdate, startDate, endDate)
        } catch (error) {
          console.log(error);
        }
      },
      onCancel() {
        console.log('ยกเลิก');
      },
    });
  };
  const getStatusLoading = async (page: number, datasearch: any, datadate: any, dataSDate: string, dataEDate: string) => {
    setLoading(true);
    try {
      const { data } = await webapi.get(
        `${APIEndpointWeb.GetStatusAgent}?search=${datasearch}&limit=${limit}&page=${page}&date=${datadate}&startDate=${dataSDate}&endDate=${dataEDate}`,
        {
          withCredentials: true,
          // headers: { Authorization: `Bearer ${cookies.shared_token}` }
        }
      );
      setResInsuranceStep(data.result ? data.result : []);
      setPaginate(data.pagination);
      setLoading(false);
      if (data.result) {
        setDatavalueStep(data.result[0]);
      } else {
        setDatavalueStep("");
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const confirm = (item: any, documentid: any) => {
    Modal.confirm({
      title: "ยืนยันได้รับประวัติการรักษา",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
      content: " ",
      okText: "ตกลง",
      onOk: async (): Promise<void> => {
        const databody = {
          document_id: documentid,
          status: "Approve"
        };
        try {
          const { data } = await webapi.post(
            `${APIEndpointWeb.GetInsuranceNotify}`,
            databody,
            {
              withCredentials: true,
              // headers: { Authorization: `Bearer ${cookies.shared_token}` }
            }
          );
          setPostMedHistory(data);
          notification.success({
            message: "ได้รับประวัติการรักษาแล้ว"
          });
        } catch (error) {
          console.log(error);
        }
      },
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#147F8B", borderRadius: "5px" } },
      cancelButtonProps: {
        style: { background: "#B5B5B5", color: "white", borderRadius: "5px" }
      }
    });
  };


  const onChangeDate = (dateString: any) => {
    const dString = dateString ? dateString.format(dateFormat) : ''
    setResSelectdate(dString);
    getStatusLoading(1, resSearchName, dString, startDate, endDate);
  };
  const onChangeStartDateEndDate = (dateStrings: any) => {
    const sDate = dateStrings ? dateStrings[0].format(dateFormat) : ''
    const eDate = dateStrings ? dateStrings[1].format(dateFormat) : ''
    setStartDate(sDate)
    setEndDate(eDate)
    getStatusLoading(1, resSearchName, resSelectdate, sDate, eDate)
  };
  const onChangePagination = async (page: number): Promise<void> => {
    gPage = page;
    await getStatusLoading(gPage, resSearchName, resSelectdate, startDate, endDate);
  };
  const handleKeyPress = (event: any, data: any): void => {
    if (event.key === "Enter") {
      getStatusLoading(1, data, resSelectdate, startDate, endDate);
    }
  };
  function disabledDate(current: any) {
    // Can not select days before today and today
    return current && current > moment().endOf('day');
  }

  return (
    <Spin tip="กำลังโหลด..." spinning={loading}>
      <Col xs={24} md={24} lg={24} xl={24} xxl={24} className="pt-5 pl-5 pr-5">
        <Card style={{ backgroundColor: '#fff', borderRadius: '25px', height: '158px', width: '100%', }}>
          <Row>
            <Col className="pt-2" xs={5} sm={5} md={5} lg={5} xl={5} xxl={5}>
              <Text className="ml-2" style={{ color: "#005A67", fontSize: "16px", fontWeight: "bold" }}>กำหนดระยะวันที่ค้นหา</Text>
              <RangePicker
                placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
                style={{ width: "100%", borderRadius: "10px", height: "34px" }}
                className="mt-3"
                format={dateFormat}
                disabledDate={disabledDate}
                onChange={onChangeStartDateEndDate}
              />
            </Col>
            <Col className="pt-2 ml-2" xs={11} sm={11} md={11} lg={11} xl={11} xxl={11} >
              <Text className="ml-2" style={{ color: "#005A67", fontSize: "16px", fontWeight: "bold" }}>
              ค้นหาข้อมูลด้วย ชื่อผู้เอาประกัน หรือเลขที่เอกสาร
              </Text>
              <Row className="mt-3">
                <Col xs={18} sm={18} md={18} lg={18} xl={18} xxl={18}>
                  <Input
                    placeholder="กรุณากรอกข้อมูล ชื่อผู้เอาประกัน หรือเลขที่เอกสาร"
                    allowClear
                    onKeyDown={(event: any) => handleKeyPress(event, resSearchName)}
                    style={{ borderRadius: "10px", height: "34px", width: '100%' }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                      const idNo = e.target.value;
                      const re = /^[A-Za-z\s0-9ก-๛]+$/;
                      if (idNo === "" || re.test(e.target.value)) {
                        setresSearchName(e.target.value);
                      }
                      if (!e.target.value) {
                        getStatusLoading(1, "", resSelectdate, startDate, endDate);
                      }
                    }}
                    value={resSearchName}
                  />
                </Col>
                <Col xs={5} sm={5} md={5} lg={5} xl={5} xxl={4} className="ml-2">
                  <Button block onClick={() => getStatusLoading(1, resSearchName, resSelectdate, startDate, endDate)}
                    style={{ borderRadius: "10px", color: "#ffffff", backgroundColor: "#147F8B", height: "34px" }}>
                    ค้นหา
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col className="pt-2" xs={7} sm={7} md={7} lg={7} xl={7} xxl={7} style={{ justifyContent: 'flex-end', display: 'grid' }}>
              <Text className="ml-2" style={{ color: "#005A67", fontSize: "16px", fontWeight: "bold" }}  >
                ค้นหาข้อมูลตามวันที่
              </Text>
              <DatePicker
                className="mt-3"
                placeholder="กรุณาเลือกวันที่"
                format={dateFormat}
                onChange={onChangeDate}
                disabledDate={disabledDate}
                style={{
                  width: "230px",
                  borderRadius: "10px",
                  height: "34px"
                }}
              />
            </Col>
          </Row>
        </Card>
      </Col>
      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
        <Row
          style={{ scrollbarGutter: "auto" }}
          className="pt-0 pl-4 pr-4"
        >
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="pt-4 pb-2"
            style={{
              height: "500px"
            }}
          >
            <div
              className=" pr-4 pl-4 pb-2 large-2"
              style={{
                height: "90%"
              }}
            >
              {resInsuranceStep && resInsuranceStep.length > 0 ? (
                resInsuranceStep.map((item: any, id: number) => (
                  <>
                    <Menu
                      selectedKeys={datadefaultSelectedKeys}
                      style={{
                        borderRadius: "20px",
                        marginBottom: "20px",
                        backgroundColor: item.status === "Rejected" ? "#E0E0E0" : '#fff'
                      }}
                    >
                      <Menu.Item
                        key={id}
                        onClick={() => getStatus(id, item)}
                        style={{ height: "100%", borderRadius: "20px", }}
                        className="border-radius-10 pt-1 pb-2"
                      >
                        <Row
                          className="m-3"
                          justify="space-around"
                        >
                          <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                            <Avatar
                              size={80}
                              style={{ backgroundColor: "#E5E5E5" }}
                              icon={
                                <div
                                  style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                  }}
                                >
                                  {resUserDisplayLogo ?
                                    <Image
                                      width={65}
                                      // height={100}
                                      preview={false}
                                      src={`data:image/jpeg;base64,${resUserDisplayLogo}`}
                                    />
                                    : ''}
                                </div>
                              }
                            />
                          </Col>
                          <Col
                            xs={18}
                            sm={18}
                            md={18}
                            lg={18}
                            xl={18}
                            xxl={18}
                            style={{ lineHeight: "25px", marginRight: "" }}
                          >
                            <Text className="font-weight-600 size-18">
                              {item.insurance_name}{" "}
                            </Text>
                            <br />
                            <Text className="font-weight-600 size-14 ">
                              วันที่ร้องขอ :{" "}
                            </Text>
                            <Text className="size-14">
                              {dayjs(item.request_date)
                                .locale("th")
                                .add(543, "year")
                                .format("DD/MMMM/YYYY") === "01/มกราคม/544"
                                ? ""
                                : dayjs(item.request_date)
                                  .locale("th")
                                  .format("DD/MM/YYYY HH:mm น."
                                  )
                              }
                              {/* {dayjs(item.request_date).subtract(7, 'hour').add(543, "year").format("DD/MMMM/YYYY") === "01/มกราคม/544"
                                ? " - " : dayjs(item.request_date).subtract(7, 'hour').add(543, "year").format("DD/MM/YYYY HH:mm น.")} */}
                            </Text>
                            <br />
                            <Text className="font-weight-600 size-14 ">
                              สถานะ :{" "}
                            </Text>
                            <Text className="font-weight-500 size-14 ">
                              {item.steps[0].step_1.status === "Pending" ? (
                                <Typography.Text style={{ color: "#147F8B" }}>
                                  รอผู้เอาประกันยินยอมให้เข้าถึงข้อมูล
                                </Typography.Text>
                              ) : item.steps[0].step_2.status ===
                                "Pending" ? (
                                <Typography.Text style={{ color: "#147F8B" }}>
                                  รอแพทย์ยืนยันข้อมูลประวัติการรักษา
                                </Typography.Text>
                              ) : item.steps[0].step_3.status ===
                                "Pending" ? (
                                <Typography.Text style={{ color: "#147F8B" }}>
                                  รอบริษัทประกันยืนยันได้รับข้อมูลประวัติการรักษา
                                </Typography.Text>
                              ) : item.steps[0].step_4.status ===
                                "Success" ? (
                                <Typography.Text style={{ color: "#147F8B" }}>
                                  เสร็จสิ้น
                                </Typography.Text>
                              ) : item.steps[0].step_4.status ===
                                "Pending" ? (
                                <Typography.Text style={{ color: "#147F8B" }}>
                                  เสร็จสิ้น
                                </Typography.Text>
                              ) : (
                                ""
                              )}
                            </Text>

                            <br />
                            <Text className="font-weight-600 size-14">
                              เลขที่เอกสารอ้างอิง :{" "}
                            </Text>
                            <Text className="size-14">
                              {item.document_id}
                            </Text>
                            {/* <br />
                            <Text className="font-weight-600 size-14">
                              เลขบัตร:{" "}
                            </Text>
                            <Text className="size-14">{item.cid}</Text> */}
                            <br />
                            <Text className="font-weight-600 size-14">
                              ชื่อ :{" "}
                            </Text>
                            <Text className="size-14">{item.name}</Text>
                            <br />
                            <Text className="font-weight-600 size-14">
                              โรงพยาบาล:{" "}
                            </Text>
                            <Text className="size-14">
                              {item.hospital_name}
                            </Text>
                            <br />
                            <Text className="font-weight-600 size-14">
                              {" "}
                              Hospital code:{" "}
                            </Text>
                            <Text className="size-14">{item.hcode}</Text>
                          </Col>
                          {/* </Col> */}
                        </Row>
                        <Col style={{ justifyContent: 'flex-end', display: 'flex' }} >
                          {item.status === 'Rejected' ?
                            (<Button className="buttonCancle" disabled>ยกเลิกแล้ว</Button>) : ''
                          }
                          {item.status === "Rejected From Hospital" ?
                            (<Button className="buttonCancle" disabled>คำร้องไม่มีประวัติการรักษา</Button>) : ''
                          }
                          {item.status === 'Approve' ?
                            (<Button className="buttonCancle" disabled>ไม่สามารถยกเลิกได้</Button>) : ''
                          }
                          {item.status === 'Pending Approval' || item.status === 'Pending HIS Approval' || item.status === 'Pending Consent' ?
                            (<Button className="buttonCancle" onClick={() => caseCancle(item.document_id)}>ยกเลิก</Button>) : ''
                          }
                        </Col>
                      </Menu.Item>
                    </Menu>
                  </>
                ))
              ) : (
                <div style={{ justifyItems: "center", marginTop: "29.6%" }}>
                  <Empty description={"ไม่มีข้อมูล"} />
                </div>
              )}
            </div>
            <Row className="mt-3" justify="center">
              <Pagination
                showSizeChanger={false}
                pageSize={limit}
                onChange={onChangePagination}
                current={paginate?.page}
                total={paginate?.total}
              />
              {/* ) : (
                ""
              )} */}
            </Row>
          </Col>

          {/* </Col> */}
          {/* ฝั่งขวา */}
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="pt-4 pr-4 pl-4 pb-2"
            style={{
              //backgroundColor: "pink",
              height: "100%"
            }}
          >
            <HomeWebStatusStep
              loading={loading}
              idStep={idStep}
              datavalueStep={datavalueStep}
              datadefaultSelectedKeys={datadefaultSelectedKeys}
            />
          </Col>
        </Row>
      </Col>
    </Spin>
  );
};

export default HomeWebStatusAgent;
